import {
  Bell, UserPlus, CheckCircle, XCircle, FileUp, Award, Megaphone, CalendarClock, Clock, AlertTriangle, BookOpen, TrendingDown,
  CalendarPlus, RefreshCw, CalendarX, MessageSquareText,
} from 'lucide-react';

// Shared between NotificationBell (dropdown) and NotificationsPage (full log)
// so every notification type gets the same label/icon everywhere it appears.
export const NOTIFICATION_TYPES = [
  { value: 'student_registered', label: 'Student Registered', icon: UserPlus, color: 'text-primary' },
  { value: 'registration_approved', label: 'Registration Approved', icon: CheckCircle, color: 'text-emerald-500' },
  { value: 'registration_rejected', label: 'Registration Rejected', icon: XCircle, color: 'text-rose-500' },
  { value: 'test_submitted', label: 'Test Submitted', icon: FileUp, color: 'text-primary' },
  { value: 'feedback_published', label: 'Feedback Published', icon: Award, color: 'text-emerald-500' },
  { value: 'broadcast', label: 'Broadcast', icon: Megaphone, color: 'text-secondary' },
  { value: 'schedule_created', label: 'Class Scheduled', icon: CalendarClock, color: 'text-primary' },
  { value: 'schedule_block_created', label: 'Weekly Class Added', icon: CalendarPlus, color: 'text-primary' },
  { value: 'schedule_block_updated', label: 'Weekly Class Updated', icon: RefreshCw, color: 'text-amber-500' },
  { value: 'schedule_block_deleted', label: 'Weekly Class Removed', icon: CalendarX, color: 'text-rose-500' },
  { value: 'class_entry_created', label: 'New Classroom Entry', icon: BookOpen, color: 'text-primary' },
  { value: 'homework_feedback', label: 'Homework Feedback', icon: MessageSquareText, color: 'text-emerald-500' },
  { value: 'fee_due_soon', label: 'Fee Due Soon', icon: Clock, color: 'text-amber-500' },
  { value: 'fee_overdue', label: 'Fee Overdue', icon: AlertTriangle, color: 'text-red-500' },
  { value: 'low_score_alert', label: 'Low Score Alert', icon: TrendingDown, color: 'text-red-500' },
  { value: 'coverage_snapshot_failed', label: 'Coverage Snapshot Failed', icon: AlertTriangle, color: 'text-red-500' },
];

const TYPE_MAP = Object.fromEntries(NOTIFICATION_TYPES.map((t) => [t.value, t]));

// In-app destination for a notification click. Only types listed here navigate;
// every other type stays click-to-mark-read. homework_feedback is student-only
// (ref_id = class entry id).
export function getNotificationTarget(n) {
  if (n.type === 'homework_feedback' && n.ref_id) {
    return `/student/classroom?entry=${encodeURIComponent(n.ref_id)}`;
  }
  return null;
}

export function getNotificationMeta(type) {
  return TYPE_MAP[type] || { value: type, label: type, icon: Bell, color: 'text-slate-400' };
}
